module.exports = __webpack_public_path__ + "static/media/Booking-02.31c5e618.png";